import { Component, OnDestroy, OnInit, inject, Signal, signal } from '@angular/core';
import { Router } from "@angular/router"
import { Message } from "primeng/api"
import { Product } from 'src/app/meta/Product.interface';
import { ProductsService } from "src/app/services/products.service"
import { StepsService } from "src/app/services/steps.service"

@Component({
  selector: "ow-product-options",
  templateUrl: "./product-options.component.html"
})
export class ProductOptionsComponent implements OnInit, OnDestroy {

  public readonly productsService = inject(ProductsService)
  private readonly router = inject(Router)
  private readonly stepsService = inject(StepsService)
  public readonly nextStepDisabled = signal<boolean>(false)
  public messages: Message[] = []
  private readonly subscriptions = [
    this.productsService.cpeProduct$.subscribe((cpeProduct) => {
      if (cpeProduct) {
        this.nextStepDisabled.set(false)
        this.messages = []
      } else {
        this.nextStepDisabled.set(true)
        this.messages = [{ severity: "error", summary: "Router auswählen", detail: "Bitte wählen Sie aus ob Sie einen eigenen Router verwenden oder welche FRITZ!Box Sie bestellen möchten." }]
      }
    })
  ]
  public productOptions = this.productsService.getChoosableProductOptions()
  public cpeOptions = this.productsService.getChoosableCpeOptions()
  public customerCpeOption = this.productsService.getCustomerCpeOption()

  ngOnInit(): void {
    this.stepsService.enableStep("product-options")
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe()
    })
  }

  public prevStep(): void {
    this.router.navigateByUrl("/availability-check")
  } 

  public nextStep(): void {
    this.stepsService.enableStep("data-form")
    this.router.navigateByUrl("/data-form")
  } 

  public addProductOption(product: Product): void {
    this.productsService.addProductOption(product)
  }

  public remProductOption(product: Product): void {
    this.productsService.remProductOption(product)
  }

  public isSelected(product: Product): boolean {
    return this.productsService.isOptionSelected(product)
  }

  public isDisabled(product: Product): boolean {
    return this.productsService.isOptionDisabled(product)
  }

}
